import { fetch, uploadFile } from ".";

export const postUploadPartnerMedia = async (file, eventId) => {
  try {
    const { data } = await fetch.post("photographers/presigned-url", {
      type: "sponsor-media",
      fileName: file.name,
      eventId,
    });

    await uploadFile(file, data.preSignedUrl);

    return data.destinationUrl;
  } catch (error) {
    throw error;
  }
};

export const getPartnerList = (eventId) =>
  fetch.get("events/sponsor-media", { params: { event_id: eventId } });

export const postCreatePartner = (payload) =>
  fetch.post("events/sponsor-media/create", payload);

export const postDeletePartner = (payload) =>
  fetch.post("events/sponsor-media/delete", payload);

export const postUpdatePartner = (payload) =>
  fetch.post("events/sponsor-media/update", payload);
